import React from 'react';
import { Popover } from '@gik/ui';
import { useUserStore } from '@gik/core/store/UserStore';
import AddToWishlistPopoverContent from './AddToWishlistPopoverContent';
import { auth } from '@gik/auth';

interface AddToWishlistPopoverProps {
  productId: number;
  inkindRouteId?: string;
  child(onClick: (ev: React.MouseEvent<HTMLElement>) => void, isLoading: boolean): React.ReactElement;
  onClose?(): void;
}

export default function AddToWishlistPopover({
  productId,
  child,
  onClose,
  inkindRouteId,
}: AddToWishlistPopoverProps): React.ReactElement {
  const userStore = useUserStore();
  const userId = userStore.id;

  const [popoverOpen, setPopoverOpen] = React.useState(false);

  function onClick() {
    if (!userId) {
      auth.loginOrSignup();
      return;
    }

    setPopoverOpen(true);
  }

  function handleClose() {
    setPopoverOpen(false);
    if (onClose) onClose();
  }

  return (
    <Popover
      trigger={child(onClick, false)}
      isOpen={popoverOpen}
      onClose={handleClose}
      noPad
      className="gik-add-to-wishlist-popover"
    >
      {popoverOpen && (
        <AddToWishlistPopoverContent productId={productId} closePopover={handleClose} inkindRouteId={inkindRouteId} />
      )}
    </Popover>
  );
}
